<template>
    <div class="map-content">
        <div class="map-left-panel">
            <div class=" map-editor-operate">
                <div class="map-title-panel">
                    <p class="map-title-panel-text">
                        {{ mapTitle }}
                    </p>
                </div>
                <div class="map-content-panel">
                    <PointCard v-if="mapLoaded" :layerShow="layerShow" />
                </div>
            </div>
        </div>
        <div class="map-right-panel">
            <MapView @map-loaded="mapLoadFinish" />
        </div>

        <div class="map-tools-panel">
            <EditorTools />
        </div>
    </div>
</template>

<script>
import PointCard from '@/components/common/PointCard.vue'
import MapView from '@/components/common/MapView.vue';
import EditorTools from '@/components/common/EditorTools.vue';


import { useMapStore } from '@/stores/mapStore';
import { updateAtlas } from '@/api/Common';

import { useRouter, useRoute } from 'vue-router';

export default {
    name: 'MapContent',
    components: {
        MapView,
        EditorTools,
        PointCard
    },
    data() {
        return {
            mapStore: null,
            layerShow: true,
            router: null,
            mapTitle: "标注列表",
            mapLoaded: false // 标记 MapView 是否加载完成
        }
    },
    mounted() {
        this.router = useRouter();
        this.route = useRoute();
        this.mapStore = useMapStore();

    },
    methods: {
        mapLoadFinish() {
            this.mapLoaded = true;
        }
    }
}
</script>

<style scoped>
@import url('@/assets/css/mapEditor.css');

.map-content {
    position: relative;
    height: 100%;
    width: 100%;
}

.map-left-panel {
    position: relative;
    min-width: 40px;
    height: inherit;
    float: left;

    display: flex;
    /* 设置为 Flex 容器 */
    flex-wrap: nowrap;
    /* 不换行 */

}

.map-title-panel {
    background-color: #1b2d3e;
    height: 46px;
    line-height: 46px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    margin-left: -10px;
    margin-top: -8px;
    margin-right: -10px;
    margin-bottom: 8px;
    padding: 0 10px;
    font-size: 14px;
    font-weight: 100;
    color: #fff;

}

.map-editor-operate {
    position: relative;
    width: 300px;
    height: inherit;
    padding: 8px;
    float: left;
}

.map-title-panel-text {
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 13px;
    margin-top: 1px;
    font-size: 16px;
    width: 200px;
    cursor: pointer;
    float: left !important;
}

.map-content-panel {

    position: relative;
    border: 1px solid #c9d3e0;
    /* height: inherit; */
    height: calc(100% - 48px);
}

.map-right-panel {
    position: relative;
    height: 100%;
    overflow: hidden;
}


.map-tools-panel {
    position: absolute;
    right: 10px;
    top: 13px;
    z-index: 1000;
}
</style>